export const ErrorMessages: { [key: string]: string } = {
  'gyms/getAll': 'gyms.fetch',

  'basketballEvents/updateUserGameReply': 'update_reply',
  'basketballEvents/updateUserPracticeReply': 'update_reply',

  'basketballEventTasks/assignUsersToBasketballEventTask': 'assign_users',

  'basketballGames/addTeamComment': 'create_comment',
  'basketballGames/getSingle': 'single_game_fetch',
  'basketballGames/getTeamComments': 'load_more_comments',
  'basketballGames/downloadRefereeBill': 'download',
  'basketballGames/setHomeGame': 'update_game',
  'basketballGames/setOwnReferees': 'update_game',

  'basketballPractices/addComment': 'create_comment',
  'basketballPractices/getComments': 'load_more_comments',
  'basketballPractices/getSingle': 'single_practice_fetch',

  'basketballCoaches/getAll': 'basketball_coaches.fetch',

  'basketballCoachLogging/create': 'generic.create',
  'basketballCoachLogging/delete': 'generic.delete',
  'basketballSwitchRequests/getUserRequests': 'switch_requests.fetch',
  'basketballSwitchRequests/create': 'switch_requests.create',
  'basketballSwitchRequests/takeOver': 'switch_requests.take_over',
  'basketballSwitchRequests/delete': 'switch_requests.delete',
  'basketballSwitchRequests/getPossibleJudgeGames':
    'switch_requests.fetch_possible_games',
  'basketballSwitchRequests/getPossibleTasks':
    'switch_requests.fetch_possible_tasks',

  'basketballTeams/getAll': 'basketball_teams_fetch',
  'basketballTeams/getAllSelect': 'basketball_teams_fetch',
  'basketballTeams/create': 'generic.create',
  'basketballTeams/update': 'generic.update',
  'basketballTeams/delete': 'generic.delete',
  'basketballTeams/savePracticeTime': 'practice_time.save',
  'basketballTeams/deletePracticeTime': 'practice_time.delete',

  'basketballUsers/getAll': 'basketball_users.fetch',
  'basketballUsers/create': 'basketball_users.create',
  'basketballUsers/update': 'basketball_users.update',
  'basketballUsers/delete': 'basketball_users.delete',

  'registration/registerUser': 'register_user',
  'registration/validateRegistrationToken': 'token_invalid_registration',

  'user/fetchUserChildUsers': 'child_users_fetch',
  'user/fetchUserData': 'userdata',
  'user/login': 'login',
  'user/logout': 'logout',

  'users/getAllCustomUserAttributes': 'custom_user_attributes.fetch',
  'users/deleteMulti': 'users.delete_multi',
  'users/activate': 'users.activate',
  'users/updateUserRights': 'users.update_user_rights',
  'users/updateUserChildren': 'users.update_children',

  'usersImporter/import': 'users_import',

  // createApi endpoints
  'apiTasks/executeMutation/assignToTask': 'tasks.assignment',
  'apiStripe/executeMutation/fetchProducts': 'stripe.fetch_products',
};
